import React, { Suspense } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Login } from "../Pages/Login";
import Loader from "Components/Elements/Loader";
import { appPageRoutes } from "./appPage.routeConfig";
import renderAppPageRoute from "./renderAppPageRoute";
import PropTypes from "prop-types";
import Downtime from "Components/Common/downtime/Downtime";
import Redirect from "../App/Redirect";

interface AppRoutesProps {
    isAuthenticated: boolean;
    userAccessInfo: any[];
}

const getDefaultRoutePath = (userAccessInfo: any[]) => {
    const firstAccess = Array.isArray(userAccessInfo) && userAccessInfo.length > 0 ? userAccessInfo[0] : "";

    const routeAliasMap: Record<string, string> = {
        common_orders: "orders",
        common_products: "products",
        common_contracts: "contract",
        frame_agreement: "contract",
        esign: "contract",
        agreement_template: "contract",
        business_hub: "deal_registration",
    };

    const route = routeAliasMap[firstAccess] || firstAccess;
    return `/${route}`;
};


const AppRoutes = ({ isAuthenticated, userAccessInfo }: AppRoutesProps) => {
    const defaultRoutePath = getDefaultRoutePath(userAccessInfo);
    const location = useLocation();

    // Check if maintenance mode is enabled and if the current path is in the maintenancePages list
    const maintenancePages = process.env.REACT_APP_PAGES_UNDER_MAINTENANCE?.split(',') || [];
    // Check the current path against the maintenancePages array and render Downtime component if it matches
    const currentPath = location.pathname.split('/')[1];
    if (maintenancePages.includes(currentPath)) {
        return <Downtime message={`${currentPath.charAt(0).toUpperCase() + currentPath.slice(1)} page is currently under maintenance. Please check back later.`} />;
    }
    return (
        <Suspense
            fallback={
                <div className="flex-center-screen">
                    <Loader />
                </div>
            }
        >
            <Routes>
            {isAuthenticated && userAccessInfo.length > 0 && (
                <>
                    <Route
                        path="/"
                        element={
                            <Navigate
                                to={defaultRoutePath}
                                replace={true}
                            />
                        }
                    />
                    {appPageRoutes.map(renderAppPageRoute)}
                </>
            )}

            <Route
                path="/login"
                element={
                    isAuthenticated ? (
                        <Navigate
                            to={defaultRoutePath}
                            replace={true}
                        />
                    ) : (
                        <Login />
                    )
                }
            />
            <Route path="/redirect" element={<Redirect />} />
            </Routes>
        </Suspense>
    );
};

AppRoutes.propTypes = {
    isAuthenticated: PropTypes.bool.isRequired,
    userAccessInfo: PropTypes.array.isRequired
}

export default AppRoutes;